import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { StatusPanelComponent } from './status-panel/status-panel.component';
import { FilterBarComponent } from '../shared/filter-bar/filter-bar.component';
import { AuthService } from '../services/auth.service';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-dashboard',
  imports: [
    StatusPanelComponent,
    MatCardModule
  ],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  readonly auth = inject(AuthService);
}
